import { Modal } from '@/components/Layout';
import { Button, TextField } from '@/components/Common';
import { TextfieldType } from '@/components/Common/TextField/TextField.types';
import { useTopicsList } from '@/components/Views/Topics/topicsList.hook';

const AddNewTopic = () => {
  const {
    addTopics,
    handleSubmit,
    register,
    isOpenTopicModal,
    isPending,
    openTopicModal,
  } = useTopicsList();

  return (
    <Modal
      isOpen={isOpenTopicModal}
      onClose={openTopicModal}
      modalStyle="bg-[#2A2A2A] w-[375px] h-[246px]"
      headerStyle="bg-[#2A2A2A]"
    >
      <div className="flex items-center justify-center w-full fex flex-col px-4">
        <h3 className="text-white text-center text-xl font-bold leading-[normal] tracking-[0.4px] font-raleway">
          Ajouter une matière
        </h3>
        <form
          className="mt-9 flex flex-col gap-4 w-full"
          onSubmit={handleSubmit(addTopics)}
        >
          <TextField
            inputStyle={{ background: '#1D1D1D' }}
            name="topic"
            register={register('name')}
            textFieldType={TextfieldType.INPUT}
            placeholder="Nom de la matière"
          />
          <Button
            type="submit"
            title={`${isPending ? 'Ajout en cours...' : 'Ajouter'}`}
            className="w-full"
          />
        </form>
      </div>
    </Modal>
  );
};

export default AddNewTopic;
